<app-page-header>
  <span class="page-title"
    ><h3>{{ isUserRole == 1 ? "Library" : "My Library" }}</h3>
    @if (isUserRole == 1) {
    <span>
      <a
        class="button is-small is-link has-tooltip-right"
        title="Add New Library"
        [routerLink]="['/policylibrary/ai-library/newclass']"
        data-tooltip="Add New Library"
        (click)="closedEmptyClassMsg()"
      >
        <i class="fa-solid fa-circle-plus"></i> </a
    ></span>
    }

    <ng-select
      [items]="elibraryList"
      [searchFn]="customSearchFn"
      bindLabel="full_name"
      bindValue="group_id"
      [clearable]="false"
      placeholder="Select Library"
      [(ngModel)]="selectedCity"
      (change)="SeletedLibrary($event)"
    >
    </ng-select>
  </span>
  <!-- <div class="d-flex flex-row align-items-center justify-content-lg-end">
<span class="field" style="margin: 0px 15px;">
  <div class="control has-icons-left has-icons-right">
    <input class="input is-small" type="text" placeholder="Search" [(ngModel)]="search" (keyup)="searchInList.next($event)">
    <span class="icon is-small is-left">
      <i class="fa fa-search"></i>
    </span>
    <span class="icon is-small is-right" *ngIf="search">
      <i class="fa fa-close" style="cursor: pointer;" (click)="search=''"></i>
    </span>
  </div>
</span>
<span *ngIf="isUserRole == 1"> <a class="button is-small is-link has-tooltip-right"  title="Add New Library" [routerLink]="['/policylibrary/ai-library/newclass']" data-tooltip="Add New Library" (click)="closedEmptyClassMsg()">
  <i class="fa-solid fa-circle-plus"></i>
</a></span>
</div> -->
  <!-- <span class="level-item input-search-box">
<div class="field">
  <p class="control has-icons-left has-icons-right">
    <input type="text" class="input" inputFocus [(ngModel)]="search" (keyup)="searchInList.next($event)" placeholder="Search here....">
    <a class="icon is-small is-left" title="Search">
      <i class="fa fa-search"></i>
    </a>
    <span class="input-bar"></span>
  </p>
</div>
</span> -->
</app-page-header>
<!-- <div class="row">
<div id="library-card-list">
  <div class="row row-cols-6">
    <ng-container *ngIf="elibraryList.length==0 else libraryListData">
      <p><span>No records found</span></p>
    </ng-container>
    <ng-template #libraryListData>
      <div class="notification-list">
        <ng-container  *ngFor="let group of elibraryList">
          <div class="card" routerLinkActive="active">
            <div class="card-body" [routerLink]="['/policylibrary/ai-library',group.group_id]">
              <div class="row">
                <div class="col-2">
                  <img [src]="profileUrl+group.group_icon" *ngIf="group.group_icon"/>
                  <empty-uname [userName]="group.full_name" [liProfile]="true" *ngIf="!group.group_icon"></empty-uname>
                </div>
                <div class="col-10 offset-0">
                  <label [title]="group.full_name">{{(group.full_name.length > 20 ) ?  (group.full_name | slice:0:20) +'...' : group.full_name}}</label>
                </div>
                <span *ngIf="isUserRole===1" class="icon position-absolute top-0 end-0 me-3" (click)="editLibrary()"><i class="fa-solid fa-pencil"></i></span>
              </div>
            </div>
          </div>

        </ng-container>
      </div>
    </ng-template>


  </div>
</div>
</div> -->
<div class="row" style="display: none">
  <div
    class="col-auto"
    [ngClass]="{ 'hide-listwrapper animated fadeIn': viewLibraryList }"
  >
    <div
      class="col second-level-menu scroll-bar elibrary-left right-box-shadow"
    >
      @if (showSearchSec) {
      <div class="menu-options level is-marginless display-flex">
        <div class="level-left">
          <div class="level-item">
            <div class="select is-small">
              <select [(ngModel)]="sortBy" (change)="getElibrary(0)">
                <option value="title">Sort A to Z</option>
                <option value="time">Sort by Recent</option>
              </select>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a class="button is-small" (click)="showSearchBox('open')">
              <i class="fa fa-search"></i>
            </a>
            <!-- <a class="button is-small has-tooltip-right" [ngClass]="{'hideNewNotify': isUserRole != 1}" title="Add New Policy" [routerLink]="['/policylibrary/ai-library/newclass']" data-tooltip="Add New Policy" (click)="closedEmptyClassMsg()">
              <i class=" fa-solid fa-circle-plus"></i>
            </a> -->
          </div>
        </div>
      </div>
      } @if (!showSearchSec) {
      <div class="menu-options level is-marginless searchBox-pad display-flex">
        <div class="level-left">
          <div class="level-item input-search-box">
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <input
                  type="text"
                  class="input"
                  inputFocus
                  [(ngModel)]="search"
                  (keyup)="searchInList.next($event)"
                  placeholder="Search here...."
                />
                <a class="icon is-small is-left" title="Search">
                  <i class="fa fa-search"></i>
                </a>
                <span class="input-bar"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <span
              class="icon is-small is-right search-return"
              (click)="showSearchBox('close')"
            >
              <i class="fa fa-times-circle"></i>
            </span>
          </div>
        </div>
      </div>
      }
      <div
        class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
        appInfiniteScroll
        infinite-scroll
        [infiniteScrollDistance]="modalScrollDistance"
        [infiniteScrollThrottle]="modalScrollThrottle"
        [scrollWindow]="false"
        (scrolled)="fetchElibraryList()"
        (reachedBottom)="onScrollDown()"
      >
        @if (elibraryList.length==0) { } @else {
        <ul class="notification-list">
          @for (group of elibraryList; track group) {
          <li
            class="cursor-pointer pos-relative chat-list"
            routerLinkActive="active"
            [ngClass]="{ hideInactiveGroup: group.group_active === false }"
          >
            <div
              class="columns is-gapless is-clearfix pos-relative display-flex align-items-center"
            >
              <div class="column is-one-quarter">
                @if (group.group_icon) {
                <img [src]="profileUrl + group.group_icon" />
                } @if (!group.group_icon) {
                <empty-uname
                  [userName]="group.full_name"
                  [liProfile]="true"
                ></empty-uname>
                }
              </div>
              <div
                class="column is-clearfix"
                [routerLink]="['/policylibrary/ai-library', group.group_id]"
              >
                <p class="list-active" [title]="group.full_name">
                  {{ group.full_name }}
                </p>
                <div>
                  @if (group.TotalLessonCount) {
                  <small class="lesson"
                    >{{ group.TotalLessonCount }} Lessons</small
                  >
                  }
                </div>
              </div>
              <div class="is-pulled-right">
                <span>
                  {{ group?.TotalUserCount }} &nbsp;<i
                    class="fa-solid fa-users"
                  ></i
                ></span>
              </div>
              <!-- <div class="is-pulled-right" *ngIf="isUserRole===1">
                <span class="icon" (click)="editLibrary()"><i class="fa-solid fa-pencil"></i></span>
              </div> -->
            </div>
          </li>
          }
          <pagination-loader
            [showFetchLoader]="showPaginateSpinner"
          ></pagination-loader>
        </ul>
        }
      </div>
    </div>

    <!-- <div *ngIf="isUserRole!=1">
<div class="modal welcome-window" [ngClass]="{'is-active': showWelcomeWindow}" *ngIf="is_tour_completed">
  <div class="modal-background"></div>
  <div class="modal-content">
    <div class="box" *ngIf="welcomeWindowName === 'welcome'">
      <div class="columns">
        <div class="column is-12 has-text-centered">
          <img [src]="'../../../../assets/images/welcome_chat.png'">
          <h2>Hi {{loggedUserDeatails?.first_name}}, Welcome to Canstring Class!</h2>
          <h4>Successfully signed up, now let us have a quick tour of the app.</h4>
        </div>
      </div>
      <div class="columns has-text-centered">
        <div class="column is-12">
          <a class="button is-small is-link" (click)="showOnboarding()">Explore Canstring class</a>
        </div>
      </div>
    </div>
  </div>
  <button class="modal-close is-large" (click)="welcomeWindow()" aria-label="close"></button>
</div>
</div> -->

    @if (totalRowCount === 0 && !viewControl.closeEmptyMessages) {
    <div class="empty-state">
      <div class="has-text-centered box">
        <i class="fa-solid fa-book" aria-hidden="true"></i>
        <p>No records found!</p>
      </div>
    </div>
    }
  </div>
  <div class="col ps-0" [ngClass]="{ 'ps-3': viewLibraryList }">
    @if (totalRowCount === 0 && !viewControl.closeEmptyMessages) {
    <div class="empty-state h-100 px-3 py-3">
      <div class="has-text-centered box">
        <i class="fa-solid fa-book"></i>
        <p>No records found!</p>
      </div>
    </div>
    }
    <!-- <router-outlet></router-outlet> -->
  </div>
  <!-- <div class="col-md-7 px-2 col-xl-8">
<router-outlet></router-outlet>
</div> -->
</div>

<div class="row">
  <router-outlet></router-outlet>
</div>
